// 商品冲调
import { MainState, ReducerState, GoodsInfo, storeName } from '@/redux/reducers/reversal/goods';
import { createActionMiddleware } from '@/redux/actions/reservation/helper';
import { GoodsReverseAction } from './constant';

// getState函数覆写
const actionWrapper = createActionMiddleware<ReducerState>(storeName);

// 初始状态
const setInitData = (data: Partial<ReducerState>) => {
  return {
    type: GoodsReverseAction.initDefaultState,
    payload: data,
  };
};

/**
 * 更新loading状态
 * 加个timer防止重复修改时闪烁
 */
let loadingTimer;
export const setLoadingStatus: (isLoading: boolean) => void = (isLoading) => {
  if (loadingTimer) {
    clearTimeout(loadingTimer);
  }
  return actionWrapper((dispatch, getState) => {
    // 和当前状态不一样
    loadingTimer = setTimeout(() => {
      loadingTimer = null;
      if (getState().isLoading !== isLoading) {
        dispatch({
          type: GoodsReverseAction.setLoadingStatus,
          payload: isLoading,
        });
      }
    });
  });
};

// 更新初始化状态
const setInitStatus = (isInit: boolean) => {
  return { type: GoodsReverseAction.setInitStatus, payload: isInit };
};

// 更新商品列表
const setGoodsList = (list: GoodsInfo[]) => {
  return {
    type: GoodsReverseAction.setGoodsList,
    payload: list,
  };
};

// 页面初始化
export const initPageState: (initFunc: () => Promise<MainState>) => void = (initFunc) => {
  return async (dispatch) => {
    try {
      // 未初始化状态
      dispatch(
        setInitData({
          isInit: false,
          isLoading: true,
          goodsList: [],
        }),
      );

      // 调用初始化方法
      const initState = await initFunc();
      // 设置初始化数据
      dispatch(setInitData(initState));
      dispatch(setInitStatus(true));
      dispatch(setLoadingStatus(false));
    } catch (_) {
      dispatch(setInitStatus(false));
    }
  };
};

// 商品信息修改
export const handleGoodsItemChange: (indexId: string, updateValue: Partial<GoodsInfo>) => void = (
  indexId,
  updateValue,
) => {
  return actionWrapper((dispatch, getState) => {
    const { goodsList } = getState();
    dispatch(
      setGoodsList(
        goodsList.map((item) => {
          if (item.indexId === indexId) {
            return {
              ...item,
              ...updateValue,
            };
          }
          return item;
        }),
      ),
    );
  });
};

// 获取全部状态
export const getMainState: (callback: (state: ReducerState) => void) => void = (callback) => {
  return actionWrapper((_, getState) => {
    try {
      callback(getState());
    } catch (e) {
      //
    }
  });
};
